import { useCallback, useEffect, useState } from 'react';

/**
 * Tema claro/escuro. O app abre claro, mesmo com o aparelho no modo escuro;
 * "Sistema" segue o aparelho e escuro forca. A escolha fica so neste aparelho
 * (localStorage) — e conveniencia, nao dado.
 * O script inline do index.html repete esta logica para a tela nao piscar.
 */
export type PreferenciaTema = 'sistema' | 'claro' | 'escuro';

const CHAVE = 'equiview.tema';
const consulta = () => window.matchMedia('(prefers-color-scheme: dark)');

export function lerPreferenciaTema(): PreferenciaTema {
  try {
    const v = localStorage.getItem(CHAVE);
    return v === 'sistema' || v === 'escuro' ? v : 'claro';
  } catch {
    return 'claro';
  }
}

function gravar(p: PreferenciaTema) {
  try {
    localStorage.setItem(CHAVE, p);
  } catch {
    // Aba anonima ou armazenamento bloqueado: o tema vale so ate recarregar.
  }
}

function aplicar(p: PreferenciaTema) {
  // O CSS so conhece `data-theme`: com "Sistema", o atributo segue o aparelho.
  // A barra do navegador (meta theme-color) e sempre Abismo, como o topo do app.
  const escuro = p === 'escuro' || (p === 'sistema' && consulta().matches);
  document.documentElement.dataset.theme = escuro ? 'dark' : 'light';
}

export function useTema() {
  const [preferencia, setPreferencia] = useState<PreferenciaTema>(lerPreferenciaTema);
  const [escuroSistema, setEscuroSistema] = useState(() => consulta().matches);

  useEffect(() => {
    aplicar(preferencia);
    if (preferencia !== 'sistema') return;
    // Com "Sistema", o aparelho pode trocar de tema com o app aberto.
    const mq = consulta();
    const mudou = () => {
      setEscuroSistema(mq.matches);
      aplicar('sistema');
    };
    mq.addEventListener('change', mudou);
    return () => mq.removeEventListener('change', mudou);
  }, [preferencia]);

  const escolher = useCallback((p: PreferenciaTema) => {
    gravar(p);
    setPreferencia(p);
  }, []);

  const escuroEfetivo = preferencia === 'escuro' || (preferencia === 'sistema' && escuroSistema);
  return { preferencia, escolher, escuroEfetivo };
}
